import {SET_SEARCH_HEADER, SET_SEARCH_ITEM, SET_SEARCH_POSITION, SET_USER} from "../actions/user_actions";
const initialState = {
    user: {},
    search_position: '',
    search_items: '',
    search_header: false
};

export function userReducer(state  = initialState,action) {
    switch (action.type) {
        case SET_USER: {
            return {...state, user: action.payload};
        }
        case SET_SEARCH_POSITION:
            return {...state, search_position: action.payload};
        case SET_SEARCH_ITEM:
            return {...state, search_items: action.payload};
        case SET_SEARCH_HEADER:
            return {...state, search_header: action.payload};
        default:
            return {...state};
    }
}
